module.exports = __webpack_public_path__ + "img/letterClo.ac0564f0.svg";